var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPythonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{display:inline;opacity:0.8;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st3{display:inline;opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st4{display:inline;fill:#FFFFFF;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "css3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Capa_1",
    className: "st1",
    d: "M88,111.6h336l-31.4,340.7L256,491l-136.6-37.8 M256,461.5L367.7,431l25.2-292.5L256,138.4v42.5 H151.7l3.7,42.4H256v42.5h-96.9l3.7,42.5H256v66.4l-47.1-12.9l-2.7-33.2h-41.6l5.6,66.4l85.8,23.1L256,461.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_4_copy",
    className: "st2",
    d: "M256,138.4l137.4,0.1l-25.1,293L256,462v-43.9l85.8-23.1l19.4-214.1H256L256,138.4z  M315.1,223.3l-3.7,42.6H256v-42.6H315.1z M307.7,308.2l-4.6,53.6L256,375.6v-67.4H307.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_6",
    className: "st3",
    d: "M256,223.3v-42.4H151.7l3.7,42.4L256,223.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_5",
    className: "st3",
    d: "M256,265.8v42.5h-93.2l-3.7-42.5H256z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_7",
    className: "st3",
    d: "M164.6,328.6h41.6l2.7,33.2l47.1,12.9v43.4L170.2,395L164.6,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_2",
    className: "st4",
    d: "M220,84.1h-49.8V20.4H220v21.2h-29.5v21.3H220V84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_3",
    className: "st4",
    d: "M280.9,20.4h-49.8V62h28.6v3.6h-28.6V85h49.8V42.6h-29.5v-3.7h29.5L280.9,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Capa_3_copy",
    className: "st4",
    d: "M341.8,20.4H292V62h28.6v3.6H292V85h49.8V42.6h-29.5v-3.7h29.5V20.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path1948_1_",
    className: "st5",
    d: "M253.5,42.4c-17.4,0.1-34.1,1.6-48.7,4.2c-43.1,7.6-51,23.6-51,53v38.9h101.9v13H153.8 h-38.3c-29.6,0-55.6,17.8-63.7,51.7c-9.4,38.8-9.8,63.1,0,103.6c7.2,30.2,24.6,51.7,54.2,51.7h35v-46.6 c0-33.6,29.1-63.3,63.7-63.3h101.8c28.3,0,51-23.3,51-51.8V99.5c0-27.6-23.3-48.4-51-53C289.1,43.6,270.9,42.3,253.5,42.4z  M198.4,73.6c10.5,0,19.1,8.7,19.1,19.5c0,10.7-8.6,19.4-19.1,19.4c-10.6,0-19.1-8.7-19.1-19.4C179.2,82.3,187.8,73.6,198.4,73.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1950_1_",
    className: "st5",
    d: "M370.3,151.3v45.3c0,35.1-29.8,64.6-63.7,64.6H204.8c-27.9,0-51,23.9-51,51.8v97.1 c0,27.6,24,43.9,51,51.8c32.3,9.5,63.2,11.2,101.8,0c25.7-7.4,51-22.4,51-51.8v-38.9H255.7v-13h101.8h51c29.6,0,40.7-20.7,51-51.7 c10.6-31.9,10.2-62.6,0-103.6c-7.3-29.5-21.3-51.7-51-51.7L370.3,151.3z M313,397.1c10.6,0,19.1,8.7,19.1,19.4 c0,10.7-8.6,19.5-19.1,19.5c-10.5,0-19.1-8.7-19.1-19.5C293.9,405.8,302.5,397.1,313,397.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonWhite);
export default __webpack_public_path__ + "static/media/python-white.3da1103e6df087935dc914e4f5665c5d.svg";
export { ForwardRef as ReactComponent };